<template>
  <div class="container">
    <div class="main">
      <div class="left">
        <div class="title">支持帮助</div>
        <div class="text">
          我们竭力为您解决，任何您在使用智签科技产品的服务过程中遇到的问题。
          我们也愿意同您一起交流各种法律常识、司法解释和常规操作。
        </div>
      </div>
      <div class="right">
        <div class="title">帮助中心</div>
        <div class="main">
          <div class="main_left">
            <div class="label" @click="goFingerPost">操作指南</div>
            <el-divider />
            <ul class="ul">
              <li>一分钟了解赋强公证办理</li>
              <li>一分钟了解公证调解</li>
              <li>一分钟学会在线签署合同</li>
              <li>赋强公证对我有什么影响？</li>
              <li>如何参与公证处调解？</li>
              <li>从哪里可以看到我的公证书？</li>
              <li>实名认证不通过？</li>
            </ul>
          </div>
          <div class="main_right">
            <div class="label" @click="goIssues">专业问题</div>
            <el-divider />
            <ul class="ul">
              <li>了解相关法律政策、典型特点、司法解释、司法行业执行标准等内容</li>
             
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {};
  },

  created() {},

  methods: {
    goFingerPost(){
      this.$emit('close')
      this.$router.push('/helpCenter/fingerPost')
    },
    goIssues(){
      this.$emit('close')
      this.$router.push('/helpCenter/issues')
    }
  },
};
</script>
  
  <style scoped lang='scss'>
.container {
  background: url(~@/assets/image/header/product_menu1.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 536px;
  .main {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .left {
      width: 21%;
      // flex: 1;
      // padding-left: 15px;
      .title {
        margin: 40px 0 24px;
        color: #000000;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #808080;
        line-height: 20px;
        width: 207px;
        height: 96px;
      }
    }
    .right {
      flex: 1;
      background-color: #fff;
      width: 900px;
      height: 100%;
      padding: 40px 0 40px 40px;
      font-size: 12px;
      .title {
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 26px;
      }
      .main {
        display: flex;
        ::v-deep {
          .el-divider--horizontal {
            margin: 8px 0;
            background: 0 0;
            border-top: 2px solid #f4f5f7;
          }
        }
        .main_left,.main_right {
          width: 390px;
          margin-right: 104px;
          .label {
            font-size: 14px;
            color: #656565;
            line-height: 20px;
            margin-bottom: 24px;
            cursor: pointer;
          }
          .ul {
            margin-top: 23px;
            color: $main_color;
            padding-left: 14px;
            list-style-type: disc;
            li {
              margin-bottom: 16px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
  